import './ga4';
import './swiper';

window.addEventListener('load', function () {
    //
    // ajout d'élément aria pour les boutons de quantité cachés visuellement dans le panier lorsque le produit concerné est vendu individuellement
    //
    document.querySelectorAll('td.product-quantity.is-sold-individually .quantity-btn').forEach(btn => {
        btn.setAttribute('aria-hidden', 'true');
        btn.setAttribute('tabindex', '-1');
    });

    const body = document.querySelector('body');

    document.querySelector('.hamburger').addEventListener('click', function () {
        if (document.querySelector('body').classList.contains('show-nav')) {
            body.classList.remove('show-nav');
            body.classList.add('hide-nav');

            setTimeout(function() {
                body.classList.remove('hide-nav');
            }, 500);
        } else {
            body.classList.remove('hide-nav');
            body.classList.add('show-nav');
        }

        return false;
    });

    // ferme le menu responsive si l'on repasse au-dessus du breakpoint xl (1200px)
    window.addEventListener('resize', function () {
        if (window.innerWidth >= 1200 && body.classList.contains('show-nav')) {
            body.classList.remove('show-nav');
        }
    });

    document.addEventListener('click', function (elem) {
        let target = elem.target;
        const updateCart = document.querySelector('[name="update_cart"]');
        
        if (target.classList.contains('quantity-btn') || target.closest('.quantity-btn')) {
            const event = new Event('change');
            const input = target.closest('.quantity').querySelector('input.qty');

            if (!target.classList.contains('quantity-btn')) {
                target = target.closest('.quantity-btn');
            }

            if (target.classList.contains('quantity-add')) {
                let addValue = parseInt(input.value) + 1;
                input.value = addValue;
                input.dispatchEvent(event);

                if (updateCart) {
                    updateCart.disabled = false;
                }

            } else if (target.classList.contains('quantity-remove')) {
                let removeValue = parseInt(input.value) - 1;

                if (removeValue == 0) {
                    removeValue = 1;
                }

                input.value = removeValue;
                input.dispatchEvent(event);

                if (updateCart) {
                    updateCart.disabled = false;
                }
            }
        }
    });

    const formSelect = document.getElementById('form-select-category');
    const allProducts = document.querySelectorAll('.type-product');

    formSelect && formSelect.addEventListener('change', function () {
        let selected = this.value;

        if (this.value == 'all') {
            allProducts.forEach(product => {
                product.style.display = 'block';
            });
        } else {
            allProducts.forEach(product => {
                if (product.classList.contains('product_cat-'+selected)) {
                    product.style.display = 'block';
                } else {
                    product.style.display = 'none';
                }
            });
        }
    });

    // Datepicker Plugin
    let nbsp = document.getElementsByClassName('ui-datepicker-trigger');

    if (nbsp.length !== 0) {
        setTimeout(function() {
            nbsp.item(0).textContent = '';
        }, 1250);
    }
});